import React from 'react';
import { Button, Col, FormControl } from 'react-bootstrap';
import { SuccessToast } from '../../../../../../utils/toasters';
import { BASE_URL_PUBLIC } from '../../../../../../utils/endpoints';
import { useTranslation } from 'react-i18next';
import CardLayout from '../../../../../../shared/components/card/CardLayout';

interface ICampaignLinkCard {
    uuid?: string;
    route: string;
    classes?: string;
}

export default function LinkToPublicCard({ uuid, route, classes }: ICampaignLinkCard) {
    const { t } = useTranslation();

    const copyCampaign = () => {
        SuccessToast(t('general.button.copied'));
        navigator.clipboard.writeText(`${BASE_URL_PUBLIC}/${route}/${uuid}`);
    };

    return (
        <CardLayout classCard={classes}>
            <h5>
                {route === 'manage'
                    ? t('brand.campaign.manage.public_manage')
                    : t('brand.campaign.briefing.public_briefing_title')}
            </h5>
            <div className="d-flex">
                <FormControl className="col mr-3" disabled value={`${BASE_URL_PUBLIC}/${route}/${uuid}`} />
                <Col xs={'auto'}>
                    <Button onClick={copyCampaign}>{t('general.button.copy')}</Button>
                </Col>
            </div>
        </CardLayout>
    );
}
